const Endpoints = {
    WISHPANDA: "https://o25kcjcwgl.execute-api.us-east-1.amazonaws.com/dev/",
    baseUrlApi: process.env.REACT_APP_API_URL
}

export default Endpoints
